import React from 'react';

export default function SVG(props: React.SVGAttributes<SVGElement>) {
    return (
        <svg
            className={props.className ? props.className : ''}
            width="112"
            height="112"
            viewBox="0 0 112 112"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43.5559 49.3889C34.75 49.3889 27.6114 42.2503 27.6114 33.4444C27.6114 24.6386 34.75 17.5 43.5559 17.5C52.3617 17.5 59.5003 24.6386 59.5003 33.4444C59.5003 42.2503 52.3617 49.3889 43.5559 49.3889ZM10.2686 77.2754L10.8169 77.9129C11.1071 78.2502 11.4023 78.583 11.7027 78.9112C19.8288 87.7912 31.2797 92.9444 43.5559 92.9444C55.3479 92.9444 66.3872 88.1919 74.4588 79.917C75.093 79.2668 75.7068 78.5968 76.299 77.9081L76.8473 77.2704L76.4157 76.5487C67.7892 62.121 56.8103 54.8333 43.5559 54.8333C30.3034 54.8333 19.3259 62.1227 10.7 76.5536L10.2686 77.2754ZM43.5559 90.6111C31.9414 90.6111 21.1127 85.7379 13.4241 77.336C13.3296 77.2328 13.2358 77.1292 13.1424 77.0251C21.2991 63.7394 31.4127 57.1667 43.5559 57.1667C55.7011 57.1667 65.8161 63.738 73.9734 77.0205C73.5874 77.4512 73.1923 77.8737 72.7885 78.2877C65.1516 86.1169 54.7125 90.6111 43.5559 90.6111ZM57.167 33.4444C57.167 40.9617 51.0731 47.0556 43.5559 47.0556C36.0387 47.0556 29.9448 40.9617 29.9448 33.4444C29.9448 25.9272 36.0387 19.8333 43.5559 19.8333C51.0731 19.8333 57.167 25.9272 57.167 33.4444Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M102.278 41.9999C102.278 52.0945 94.095 60.2777 84.0004 60.2777C73.9059 60.2777 65.7227 52.0945 65.7227 41.9999C65.7227 31.9054 73.9059 23.7222 84.0004 23.7222C94.095 23.7222 102.278 31.9054 102.278 41.9999ZM68.056 41.9999C68.056 50.8058 75.1946 57.9444 84.0004 57.9444C92.8063 57.9444 99.9449 50.8058 99.9449 41.9999C99.9449 33.1941 92.8063 26.0555 84.0004 26.0555C75.1946 26.0555 68.056 33.1941 68.056 41.9999Z"
                fill="#7448FE"
            />
            <path
                d="M76.2223 43.1666H91.7779C92.4222 43.1666 92.9445 42.6442 92.9445 41.9999C92.9445 41.3556 92.4222 40.8333 91.7779 40.8333H76.2223C75.578 40.8333 75.0557 41.3556 75.0557 41.9999C75.0557 42.6442 75.578 43.1666 76.2223 43.1666Z"
                fill="#7448FE"
            />
            <path
                d="M82.8336 34.2223V49.7779C82.8336 50.4222 83.356 50.9445 84.0003 50.9445C84.6447 50.9445 85.167 50.4222 85.167 49.7779V34.2223C85.167 33.578 84.6447 33.0557 84.0003 33.0557C83.356 33.0557 82.8336 33.578 82.8336 34.2223Z"
                fill="#7448FE"
            />
        </svg>
    );
}
